import { useModelSizeStorage } from '@core-ui/model-size-storage';
import { ProductCardProps, ProductInfo } from '@core-ui/product-card/types';

const SCROLLED_CID = 'scrolledCid';
const SCROLL_Y_POSITION = 'scrollYPosition';

const productHasModelSize = (productInfo: ProductInfo) => {
  const { setModelSizeSelected } = useModelSizeStorage();

  if (productInfo.modelSize) {
    setModelSizeSelected(productInfo.modelSize);
  }
};

const productHasPCID = (pcid: string) => {
  if (pcid != null) {
    globalThis?.window.sessionStorage.setItem(SCROLLED_CID, pcid);
  }
};

const setScrollYPosition = () => {
  globalThis?.window.sessionStorage.setItem(SCROLL_Y_POSITION, `${globalThis?.window.scrollY}`);
};

export type HandleClickProps = Pick<ProductCardProps, 'productInfo' | 'pcid'>;

export const handleProductClick = ({ productInfo, pcid }: HandleClickProps) => {
  try {
    productHasModelSize(productInfo);
    productHasPCID(pcid);
    setScrollYPosition();
    return true;
  } catch {
    // sessionStorage not supported in Safari private mode prior to Version 11
    return false;
  }
};
